import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useEffect } from 'react';
import { HashRouter } from "react-router-dom";
import { LogViewModel } from "./features/log/log-view-model";
import { NotLazyRoutes } from "./routes/lazy-routes";
import { LogAlert } from "./ui/log/log-alert";
import { Navbar } from "./ui/navbar";
import { preventNavigation } from "./utils/prevent-navigation";
import { RouteChangeScript } from "./utils/route-change";
import { useViewModel } from "./viewmodel/use-view-model";
export const App = observer(() => {
    const logVM = useViewModel(LogViewModel);
    useEffect(() => {
        const handleUnhandledRejection = (evt) => {
            logVM.logAppError(`Unhandled rejection: ${evt.reason}`);
            evt.preventDefault();
        };
        window.addEventListener('unhandledrejection', handleUnhandledRejection);
        return () => {
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
    }, [logVM]);
    useEffect(() => {
        return preventNavigation();
    }, []);
    return (_jsxs(HashRouter, { children: [_jsx(RouteChangeScript, {}), _jsx(Navbar, {}), _jsx(LogAlert, {}), _jsx("div", { className: "container-md", children: _jsx(NotLazyRoutes, {}) })] }));
});
